import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import MainLayout from './components/layout/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import Videos from './pages/Videos';
import Employees from './pages/Employees';
import Events from './pages/Events';
import Finance from './pages/Finance';
import Tasks from './pages/Tasks';
import Equipment from './pages/Equipment';
import Communications from './pages/Communications';
import Reports from './pages/Reports';
import Alerts from './pages/Alerts';
import Settings from './pages/Settings';
import Classes from './pages/Classes';
import Sponsorship from './pages/Sponsorship';
import DailyExpenses from './pages/DailyExpenses';
import RentalEquipment from './pages/RentalEquipment';
import ActivityLogs from './pages/ActivityLogs';
import Debts from './pages/Debts';
import OfficeDebts from './pages/OfficeDebts';

function ProtectedRoute({ children, roles }) {
  const { user, isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user?.role)) return <Navigate to="/" replace />;
  return <MainLayout>{children}</MainLayout>;
}

function AppRoutes() {
  const { isAuthenticated } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/projects" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
      <Route path="/videos" element={<ProtectedRoute><Videos /></ProtectedRoute>} />
      <Route path="/employees" element={<ProtectedRoute roles={['admin','manager']}><Employees /></ProtectedRoute>} />
      <Route path="/events" element={<ProtectedRoute roles={['admin','manager']}><Events /></ProtectedRoute>} />
      <Route path="/finance" element={<ProtectedRoute roles={['admin','manager']}><Finance /></ProtectedRoute>} />
      <Route path="/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
      <Route path="/equipment" element={<ProtectedRoute roles={['admin','manager']}><Equipment /></ProtectedRoute>} />
      <Route path="/communications" element={<ProtectedRoute><Communications /></ProtectedRoute>} />
      <Route path="/classes" element={<ProtectedRoute roles={['admin','manager']}><Classes /></ProtectedRoute>} />
      <Route path="/sponsership" element={<ProtectedRoute roles={['admin','manager']}><Sponsorship /></ProtectedRoute>} />
      <Route path="/daily-expenses" element={<ProtectedRoute roles={['admin','manager']}><DailyExpenses /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute roles={['admin','manager']}><Reports /></ProtectedRoute>} />
      <Route path="/rental-equipment" element={<ProtectedRoute roles={['admin','manager']}><RentalEquipment /></ProtectedRoute>} />
      <Route path="/alerts" element={<ProtectedRoute><Alerts /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute roles={['admin']}><Settings /></ProtectedRoute>} />
      <Route path="/activity-logs" element={<ProtectedRoute roles={['admin']}><ActivityLogs /></ProtectedRoute>} />
      <Route path="/debts" element={<ProtectedRoute roles={['admin']}><Debts /></ProtectedRoute>} />
      <Route path="/office-debts" element={<ProtectedRoute roles={['admin','manager']}><OfficeDebts /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster
          position="bottom-left"
          toastOptions={{
            style: { background: '#ffffff', color: '#1e293b', border: '1px solid #e5e7eb', borderRadius: '12px', fontSize: '14px', direction: 'rtl', boxShadow: '0 4px 16px rgba(16,24,40,0.1)' },
            success: { iconTheme: { primary: '#22c55e', secondary: '#fff' } },
            error: { iconTheme: { primary: '#ef4444', secondary: '#fff' } },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
